<template>
  <div>
    <el-table
      :data="whitelist.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column width="100%">
        <template slot-scope="props">
          <img
            v-if="props.row.image_url"
            class="avatar"
            :src="props.row.image_url"
          />
          <img
            v-else
            class="avatar"
            :src="`https://syncvault.com/static/apple-touch-icon.png`"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Channel"
        prop="channelId"
        sortable
      ></el-table-column>
      <el-table-column label="Title" prop="title" sortable></el-table-column>
      <el-table-column label="Published" prop="published_at" sortable>
        <template slot-scope="props">
          {{ props.row.published_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteW(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @current-change="currentChange"
      :current-page.sync="whitelist.current_page"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="whitelist.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeWhitelist', [
      'whitelist',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeWhitelist', ['setPage']),
    ...mapActions('youtubeWhitelist', ['readWhitelist', 'destroy']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readWhitelist()
    },
    deleteW(row) {
      this.$confirm(
        'You will delete this channel from whitelist. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.destroy(row.channelId)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.readWhitelist()
  }
}
</script>
]
